import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Timeline from "./Timeline";

export default function Work() {
  const theme = useTheme();
  return (
    <Box sx={{ width: "92%", margin: "0 auto" }} id="work">
      <Typography
        variant="h1"
        sx={{
          color: theme.palette.common.white,
          marginTop: "26px",
          letterSpacing: "1px",
          lineHeight: "58px",
          width: "80%",
        }}
      >
        Places I've worked
      </Typography>
      <Timeline />
    </Box>
  );
}
